export const TOGGLE_TRAFFIC = 'TOGGLE_TRAFFIC'

export function showTrafficReducer (state = false, action) {
    switch (action.type){
        case TOGGLE_TRAFFIC:
            return !state
        default: return state
    }
}